import { render } from "./CreateSoundtrackPage.vue?vue&type=template&id=146e2491"
import script from "./CreateSoundtrackPage.vue?vue&type=script&lang=js"
export * from "./CreateSoundtrackPage.vue?vue&type=script&lang=js"

import "./CreateSoundtrackPage.vue?vue&type=style&index=0&id=146e2491&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__